import React, { useState, useEffect, useContext } from "react";
// @material-ui/core components
import { makeStyles, CircularProgress } from "@material-ui/core";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { TextInput } from "Ficha/components/TextInput";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
import { UserContext } from 'context/userContext'
import { useForm } from 'react-hook-form'
import firebase from '../firebase/config';
import { createCheckoutSession, goToBillingPortal } from "firebase/checkout";
import { atualizarPerfil } from 'firebase/firestoreData'
import GerenciarButton from "../firebase/GerenciarButton";
import CheckoutButton from "../firebase/CheckoutButton";
import { Assinar } from "../firebase/AssinarButton";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  field: {
    margin: 10,
    maxWidth: '95%'
  },
  updateBtn: {
    maxWidth: 400,
    margin: '20px 40px 40px 20px'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
    color: 'white',
  },
  gerenciarBtn: {
    maxWidth: '100%',
  }
};

const useStyles = makeStyles(styles);

export default function Profile() {
  const classes = useStyles();
  const { signOut, currentUser, userProfile, isPro } = useContext(UserContext)
  const [dias, setDias] = useState("")
  const [prevUpdated, setPrevUpdated] = useState(false)
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const [loadingCheckOut, setLoadingCheckOut] = useState(false);
  const { register, handleSubmit, setValue } = useForm()

  // caso o usuário não tenha perfil, passar data avulsa para poder ler a data
  const profile = userProfile ? userProfile : { date: firebase.firestore.Timestamp.fromDate(new Date()) }

  useEffect(() => {
    setValue('nomeCompleto', profile.nomeCompleto);
    setValue('email', profile.email);
    setValue('nomeExibicao', profile.nomeExibicao);
    setValue('cidade', profile.cidade);
    setValue('estado', profile.estado);
    setValue('crm', profile.crm);
    setValue('telefone', profile.telefone);
    try {
      setDias(Math.ceil((new Date() - profile.date.toDate()) / 86400000))
    } catch (error) {
      console.log("Erro: ", error)
    }
    setPrevUpdated(profile.prevUpdated)
  }, [currentUser, setValue, profile]);

  function handleCloseMessage() {
    setShowSuccessMessage(false)
  }

  const onSubmit = data => {
    atualizarPerfil(currentUser.uid, data)
    setShowSuccessMessage(true)
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Editar Perfil</h4>
              <p className={classes.cardCategoryWhite}>Favor preencher todos os
                campos com atenção. As informações só poderão ser atualizadas após 30 dias.</p>
            </CardHeader>
            <form onSubmit={handleSubmit(onSubmit)}>
              <CardBody>
                <GridContainer className={classes.grid}>
                  <TextInput label="Nome Completo" name="nomeCompleto" className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                  <TextInput label="Email" name="email" className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                  <TextInput label="Nome de Exibição" name="nomeExibicao" className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                  <TextInput label="Cidade" name="cidade" fieldsize={6} className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                  <TextInput label="Estado" name="estado" fieldsize={6} className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                  <TextInput label="CRM" name="crm" fieldsize={6} className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                  <TextInput label="Telefone" name="telefone" fieldsize={6} className={classes.field} InputLabelProps={{ shrink: true }} ref={register} required />
                </GridContainer>
              </CardBody>
              <Button disabled={prevUpdated && dias < 30} className={classes.updateBtn} type="submit" color="primary">Atualizar Perfil</Button>
              * Última atualização há {dias} dia(s)
            </form>
          </Card>
          <CustomSnackbar open={showSuccessMessage} onClose={handleCloseMessage} message={"Perfil atualizado com sucesso"} />
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <img src={currentUser.photoURL} alt="..." />
            </CardAvatar>
            <CardBody profile>
              <h6 className={classes.cardCategory}>{currentUser.displayName}</h6>
              <p className={classes.description}>
                As informações aqui fornecidas serão usadas para preenchimento automático
                da ficha de avaliação, termo de consentimento e demais documentos gerados.
              </p>
              {isPro ? (
                <GerenciarButton />
              ) : (
                (
                  <Button onClick={() => Assinar(currentUser.uid)} color="primary">
                    Assinar
                  </Button>

                )
              )}
              <Button color="primary" >
                <div style={{ color: 'white' }} onClick={() => signOut()}>SAIR</div>
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
